import React from 'react';

const StoreOverallsIndex = React.lazy(() => import("./index"))
const NewStoreOveralls = React.lazy(() => import("./new"))
const EditStoreOveralls = React.lazy(() => import("./edit"))

export default[
	{path:'/store/overalls/:id/edit',component: EditStoreOveralls,name:'Edit StoreOverall'},
	{path:'/store/overalls/new',component: NewStoreOveralls,name:'New StoreOverall'},  
	{path:'/store/overalls',component: StoreOverallsIndex,name:'StoreOveralls'}, 
]

// import StoreOverallsRoutes from "modules/store/overalls/web/routes"
// routes = _.concat(routes,StoreOverallsRoutes)
